<span class="flex" [innerHTML]="$svgHtml()"></span>
